"use strict";

import Vue from "vue";
import VueRouter from "vue-router";
import AppError from "../utils/AppError.js";
import store from "../store/index.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    component: () => import("@/views/NotFound.vue")
  },
  {
    path: "/",
    redirect: { name: "Home" }
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("@/views/Home.vue")
  },
  {
    path: "/aboutus",
    name: "AboutUs",
    component: () => import("@/views/AboutUs.vue")
  },
  {
    path: "/volunteering",
    name: "Volunteering",
    component: () => import("@/views/Volunteering.vue")
  },
  {
    path: "/donation",
    name: "Donation",
    component: () => import("@/views/Donation.vue")
  },
  {
    path: "/myvolunteerings",
    name: "MyVolunteerings",
    meta: {
      requiresAuth: true,
      requiresVolunteer: true
    },
    component: () => import("@/views/MyVolunteerings.vue")
  },
  {
    path: "/profile",
    name: "Profile",
    meta: {
      requiresAuth: true
    },
    component: () => import("@/views/Profile.vue")
  },
  {
    path: "/recoverpassword",
    name: "RecoverPassword",
    component: () => import("@/views/RecoverPassword.vue")
  },
  {
    path: "/recoverpasswordconfirm/:token",
    name: "RecoverPasswordConfirm",
    component: () => import("@/views/RecoverPasswordConfirm.vue")
  },
  {
    path: "/volunteering-detail/:volunteeringId",
    name: "VolunteeringDetail",
    component: () => import("@/views/VolunteeringDetail.vue"),
    props: true
  },
  {
    path: "/donation-detail/:donationId",
    name: "DonationDetail",
    component: () => import("@/views/DonationDetail.vue"),
    props: true
  },
  {
    path:
      "/volunteering/:volunteeringId/timeslot/:timeSlotId/confirmattendance/:code",
    name: "VolunteeringConfirmAttendance",
    component: () => import("@/views/VolunteeringConfirmAttendance.vue"),
    props: true
  },
  {
    path: "/statistics",
    name: "Statistics",
    meta: {
      requiresAuth: true,
      requiresVolunteer: true
    },
    component: () => import("@/views/Statistics.vue")
  },
  {
    path: "/confirmSignup/:token",
    name: "ActiveAccount",
    component: () => import("@/views/ActiveAccount.vue"),
    props: true
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  // Get route permissions hierarchically
  let toMeta = {
    requiresAuth: false,
    requiresVolunteer: false
  };
  to.matched.forEach(item => {
    let meta = item.meta;
    if (meta.requiresAuth !== undefined)
      toMeta.requiresAuth = meta.requiresAuth;
    if (meta.requiresVolunteer !== undefined)
      toMeta.requiresVolunteer = meta.requiresVolunteer;
  });

  if (
    (toMeta.requiresAuth === true &&
      store.getters["Auth/isAuthenticated"] === false) ||
    (toMeta.requiresVolunteer === true &&
      store.getters["Auth/getUser"]["type"] !== 1)
  ) {
    const error = new AppError("ROUTE_NO_PERMISSION");
    store.dispatch("Alert/showError", error.message);
    next(error);
    return;
  }

  next();
});

export default router;
